(function () {
  const popup = document.getElementById('ExitIntentPopup');
  if (!popup) return;

  const STORAGE_KEY = 'haldiram-exit-popup-shown-at';
  const days = Number(popup.dataset.days) || 7;
  const ARM_DELAY_MS = 5000;

  function shownRecently() {
    try {
      const shownAt = Number(localStorage.getItem(STORAGE_KEY));
      return Boolean(shownAt) && Date.now() - shownAt < days * 24 * 60 * 60 * 1000;
    } catch (err) {
      return false;
    }
  }

  function rememberShown() {
    try {
      localStorage.setItem(STORAGE_KEY, String(Date.now()));
    } catch (err) {}
  }

  if (shownRecently()) return;

  let armed = false;
  let done = false;
  let lastFocused = null;
  setTimeout(() => {
    armed = true;
  }, ARM_DELAY_MS);

  // Don't stack on top of the store's existing notice popup or an open cart drawer.
  function somethingElseOpen() {
    const notice = document.querySelector('.order-advisory');
    if (notice && getComputedStyle(notice).display !== 'none') return true;
    const drawer = document.querySelector('cart-drawer');
    return Boolean(drawer && drawer.classList.contains('active'));
  }

  function open() {
    if (!armed || done || somethingElseOpen()) return;
    done = true;
    rememberShown();
    lastFocused = document.activeElement;
    popup.hidden = false;
    document.body.classList.add('exit-popup-open');
    const close = popup.querySelector('.exit-popup__close');
    if (close) close.focus();
    removeTriggers();
  }

  function close() {
    popup.hidden = true;
    document.body.classList.remove('exit-popup-open');
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  popup.querySelectorAll('[data-exit-popup-close]').forEach((el) => el.addEventListener('click', close));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !popup.hidden) close();
  });

  // Desktop: pointer leaves through the top edge (towards tabs / address bar).
  function onMouseOut(event) {
    if (!event.relatedTarget && event.clientY <= 0) open();
  }

  // Touch devices have no pointer exit; a fast scroll back up after reading
  // part of the page is the usual stand-in.
  let deepestScroll = 0;
  let lastY = window.scrollY;
  let lastTime = Date.now();
  function onScroll() {
    const y = window.scrollY;
    const now = Date.now();
    const pageHeight = document.documentElement.scrollHeight - window.innerHeight;
    deepestScroll = Math.max(deepestScroll, y);
    const fastUp = lastY - y > 150 && now - lastTime < 400;
    if (fastUp && pageHeight > 0 && deepestScroll / pageHeight > 0.3) open();
    lastY = y;
    lastTime = now;
  }

  function removeTriggers() {
    document.removeEventListener('mouseout', onMouseOut);
    window.removeEventListener('scroll', onScroll);
  }
  // Pointer exit only happens with a mouse, so it is safe everywhere; the scroll
  // stand-in is limited to touch-first devices so desktop readers aren't interrupted.
  document.addEventListener('mouseout', onMouseOut);
  if (window.matchMedia('(hover: none)').matches) {
    window.addEventListener('scroll', onScroll, { passive: true });
  }
})();
